import { render } from "./StarTabBar.vue?vue&type=template&id=798e1895&scoped=true&ts=true"
import script from "./StarTabBar.vue?vue&type=script&lang=ts"
export * from "./StarTabBar.vue?vue&type=script&lang=ts"

import "./StarTabBar.vue?vue&type=style&index=0&id=798e1895&scoped=true&lang=css"
import "./StarTabBar.vue?vue&type=style&index=1&id=798e1895&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798e1895"]])

export default __exports__